import React, { useEffect, useContext, useState } from 'react';
import { cloneDeep } from 'lodash';
import clsx from 'clsx';

import {
    Card,
    CardContent,
    Container,
    Typography,
    Grid,
    Avatar,
    Divider,
    IconButton,
    colors
} from '@material-ui/core';

import {
    AvatarSkeleton,
    FieldError,
    UploadFile
} from '../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    Switch,
    TextField,
    CheckboxWithLabel
} from 'formik-material-ui';

import { PageContext } from '../PageContext';
import { PluginContext } from '../../../contexts/PluginContext';
import { ToastContext } from '../../../contexts/ToastContext';

import { ImageType, MaxFileSize } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import DeleteIcon from "@material-ui/icons/Delete";
import ImageIcon from '@material-ui/icons/Image';

import { makeStyles } from '@material-ui/core/styles';
const avatarSize = 270;
const useStyles = makeStyles((theme) => ({
    root: {
    },
   sectionTitle: {
      color: "#7957d5"
   },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        marginLeft: "-6px"
    },
    button: {
        marginLeft: 5,
        marginRight: 5,
    },
    avatarSkeleton: {
        marginBottom: theme.spacing(1)
    },
    avatar: {
        width: avatarSize,
        height: avatarSize
    },
    error: {
        textAlign: "center",
        display: "block",
        fontSize: "1.2em"
    }
}));

export const MediaIconForm = ({
    formRef,
    errors,
    validationSchema,
    disabled,
    upload,
    onBlur,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const { t } = useTranslation();

    const {
        state,
        mergeSettings
    } = useContext(PageContext);

    const {
        getAssetUrl
    } = useContext(PluginContext);

    const {
        showWarningMessage
    } = useContext(ToastContext);

    const {
        settings
    } = state;

    const [appSplash, setAppSplash] = useState(settings.appSplashImage);
    const [appIcon, setAppIcon] = useState(settings.appIcon);
    const [menuHeader, setMenuHeader] = useState(settings.menuHeaderBackgroundImage);
    const [loginPage, setLoginPage] = useState(settings.loginPageImage);
    const setImage = (imageType, file) => {
        switch (imageType) {
            case ImageType.AppSplash:
                setAppSplash(URL.createObjectURL(file));
                break;
            case ImageType.AppIcon:
                setAppIcon(URL.createObjectURL(file));
                break;
            case ImageType.MenuHeader:
                setMenuHeader(URL.createObjectURL(file));
                break;
            case ImageType.LoginPage:
                setLoginPage(URL.createObjectURL(file));
            default:
                break;
        }
    }

    const uploadfileAsync = async (imageType, data, file) => {
        if (upload) {
            const storedImageInfo = await upload(imageType, data, file);
            if (storedImageInfo !== null) {
                setImage(imageType, file);
                switch (imageType) {
                    case ImageType.AppSplash:
                        mergeSettings({ appSplashImage: storedImageInfo.publicUrl });
                        break;
                    case ImageType.AppIcon:
                        mergeSettings({ appIcon: storedImageInfo.publicUrl });
                        break;
                    case ImageType.MenuHeader:
                        mergeSettings({ menuHeaderBackgroundImage: storedImageInfo.publicUrl });
                        break;
                    case ImageType.LoginPage:
                        mergeSettings({ loginPageImage: storedImageInfo.publicUrl });
                        break;
                    default:
                        break;
                }
                return true;
            }
        }
        return false;
    }

    const getInitialValues = () => {
        return {
            appSplashImage: settings.appSplashImage ? settings.appSplashImage : "",
            appIcon: settings.appIcon ? settings.appIcon : "",
            menuHeaderBackgroundImage: settings.menuHeaderBackgroundImage ? settings.menuHeaderBackgroundImage : "",
            loginPageImage: settings.loginPageImage ? settings.loginPageImage : "",
        };
    }

    const fileDropHandler = (imageType, file) => {
        if (file.type.includes('image')
            && file.name.endsWith(".png")) {
            if (file.size <= MaxFileSize.Max5MB) {
                return true;
            } else {
                showWarningMessage(t("MessageWrongFileSize5"));
                return false;
            }
        } else {
            showWarningMessage(t("MessageWrongImageFormat"));
            return false;
        }
    }

    const resetImageHandler = (imageType) => {
        switch (imageType) {
            case ImageType.AppSplash:
                setAppSplash(null);
                mergeSettings({ appSplashImage: "" });
                break;
            case ImageType.AppIcon:
                setAppIcon(null);
                mergeSettings({ appIcon: "" });
                break;
            case ImageType.MenuHeader:
                setMenuHeader(null);
                mergeSettings({ menuHeaderBackgroundImage: "" });
                break;
            case ImageType.LoginPage:
                setLoginPage(null);
                mergeSettings({ loginPageImage: "" });
                break;
            default:
                break;
        }
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) {
            onSubmit(values, () => actions.setSubmitting(false));
        }
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardContent>
                <Container maxWidth="lg" className={classes.content}>
                    <Formik
                        enableReinitialize
                        initialValues={getInitialValues()}
                        onSubmit={submitClickHandler}
                        innerRef={formRef}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={true}
                        validate={(values) => {
                            if (onBlur) onBlur(values);
                        }}>
                        {(props) => {
                            const {
                                values,
                                isSubmitting,
                                handleSubmit,
                                setFieldValue
                            } = props;
                            return (
                                <Form noValidate autoComplete="off">
                                    <Grid container spacing={4}>
                                     <Grid item xs={12}>
                                        <Typography className={classes.sectionTitle} variant="h6">
                                           {"Launcher Icon"}
                                        </Typography>
                                     </Grid>

                                        <Grid item xs={12}>
                                            <Grid container justify="center">
                                                <Grid item xs={4} style={{ textAlign: "center" }}>
                                                    <img
                                                        src={getAssetUrl("images/image-appicon.png")}
                                                        style={{ maxWidth: '80%', height: 'auto', borderRadius: 8, objectFit: 'contain' }}
                                                    />
                                                </Grid>
                                                <Grid container item xs={8} alignItems="center" justify="center">
                                                    <Grid item>
                                                        <AvatarSkeleton
                                                            width={avatarSize}
                                                            height={avatarSize}
                                                            src={appIcon}
                                                            variant="circle">
                                                            <Avatar
                                                                className={classes.avatar}
                                                                alt="app-icon">
                                                                <ImageIcon />
                                                            </Avatar>
                                                        </AvatarSkeleton>
                                                    </Grid>
                                                    {appIcon &&
                                                        <Grid item>
                                                            <IconButton
                                                                style={{ color: "#FF2B56" }}
                                                                disabled={disabled}
                                                                onClick={(e) => resetImageHandler(ImageType.AppIcon)}>
                                                                <DeleteIcon fontSize="large" />
                                                            </IconButton>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12}>
                                                        <FieldError
                                                            className={classes.error}
                                                            name="appIcon"
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <UploadFile
                                                            title={t("LabelAppIcon")}
                                                            singleFile
                                                            disabled={disabled}
                                                            onFileDrop={(files) => fileDropHandler(ImageType.AppIcon, files[0])}
                                                            upload={(data, file) => uploadfileAsync(ImageType.AppIcon, data, file)}
                                                            helpText={t("LabelUploadHelp")}
                                                            uploadButtonText={t("LabelUploadFile")}
                                                            removeButtonText={t("LabelRemoveFile")}
                                                            removeAllButtonText={"LabelRemoveAllFiles"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <br />
                                        </Grid>
                                       { /*
                                        <Grid item xs={12}>
                                            <Grid container justify="center">
                                                <Grid container item xs={8} alignItems="center" justify="center">
                                                    <Grid item>
                                                        <AvatarSkeleton
                                                            width={avatarSize}
                                                            height={avatarSize}
                                                            src={menuHeader}
                                                            variant="circle">
                                                            <Avatar
                                                                className={classes.avatar}
                                                                alt="app-menuheader">
                                                                <ImageIcon />
                                                            </Avatar>
                                                        </AvatarSkeleton>
                                                    </Grid>
                                                    {menuHeader &&
                                                        <Grid item>
                                                            <IconButton
                                                                style={{ color: "#FF2B56" }}
                                                                disabled={disabled}
                                                                onClick={(e) => resetImageHandler(ImageType.MenuHeader)}>
                                                                <DeleteIcon fontSize="large" />
                                                            </IconButton>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12}>
                                                        <FieldError
                                                            className={classes.error}
                                                            name="menuHeaderBackground"
                                                            errors={errors}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <UploadFile
                                                            title={t("LabelMenuHeaderBackground")}
                                                            singleFile
                                                            disabled={disabled}
                                                            onFileDrop={(files) => fileDropHandler(ImageType.MenuHeader, files[0])}
                                                            upload={(data, file) => uploadfileAsync(ImageType.MenuHeader, data, file)}
                                                            helpText={t("LabelUploadHelp")}
                                                            uploadButtonText={t("LabelUploadFile")}
                                                            removeButtonText={t("LabelRemoveFile")}
                                                            removeAllButtonText={"LabelRemoveAllFiles"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ textAlign: "center" }}>
                                                    <img
                                                        src={getAssetUrl("images/image-menuheader.png")}
                                                        style={{ maxWidth: '80%', height: 'auto', borderRadius: 8, objectFit: 'contain' }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <br />
                                        </Grid>
                                        <Grid item xs={12}>
                                           <Grid container justify="center">
                                              <Grid item xs={4} style={{ textAlign: "center" }}>
                                                 <img
                                                    src={getAssetUrl("images/image-loginpage.png")}
                                                    style={{ maxWidth: '80%', height: 'auto', borderRadius: 8, objectFit: 'contain' }}
                                                 />
                                              </Grid>
                                              <Grid container item xs={8} alignItems="center" justify="center">
                                                 <Grid item>
                                                    <AvatarSkeleton
                                                       className={classes.avatarSkeleton}
                                                       width={avatarSize}
                                                       height={avatarSize}
                                                       src={loginPage}
                                                       variant="circle">
                                                       <Avatar
                                                          className={classes.avatar}
                                                          alt="login-page">
                                                          <ImageIcon />
                                                       </Avatar>
                                                    </AvatarSkeleton>
                                                 </Grid>
                                                 {loginPage &&
                                                    <Grid item>
                                                       <IconButton
                                                          style={{ color: "#FF2B56" }}
                                                          disabled={disabled}
                                                          onClick={(e) => resetImageHandler(ImageType.LoginPage)}>
                                                          <DeleteIcon fontSize="large" />
                                                       </IconButton>
                                                    </Grid>
                                                 }
                                                 <Grid item xs={12}>
                                                    <FieldError
                                                       className={classes.error}
                                                       name="loginPageImage"
                                                       errors={errors}
                                                    />
                                                 </Grid>
                                                 <Grid item xs={12}>
                                                    <UploadFile
                                                       title={t("LabelLoginPage")}
                                                       singleFile
                                                       disabled={disabled}
                                                       onFileDrop={(files) => fileDropHandler(ImageType.LoginPage, files[0])}
                                                       upload={(data, file) => uploadfileAsync(ImageType.LoginPage, data, file)}
                                                       helpText={t("LabelUploadHelp")}
                                                       uploadButtonText={t("LabelUploadFile")}
                                                       removeButtonText={t("LabelRemoveFile")}
                                                       removeAllButtonText={"LabelRemoveAllFiles"}
                                                    />
                                                 </Grid>
                                              </Grid>
                                           </Grid>
                                           <br />
                                           <Divider />
                                        </Grid>
                                        */ }
                                    </Grid>
                                </Form>
                            );
                        }}
                    </Formik>
                </Container>
            </CardContent>
        </Card>
    );
}